<script>
import options from './HoldetsDonationer.options'
export default options
</script>

<template>
  <article class="kb-holdets-donationer">
    <div class="kb-holdets-donationer__header">
      <h2 class="kb-holdets-donationer__title">
        {{ getLabel('title') }}
      </h2>
      <a :href="donationFormUrl" class="kb-button">{{ getLabel('donate') }}</a>
    </div>

    <ul class="kb-holdets-donationer__list" v-for="donation, index in listOfDonations" :key="index">
      <li class="kb-holdets-donationer__list-item">
        <DonationCard modifierClass="kb-holdets-donationer--card-modifier" :result="donation"></DonationCard>
      </li>
    </ul>
    <div class="kb-holdets-donationer__footer" v-if="showLoadMore">
      <button class="kb-button kb-button--full-color" @click="loadMore" :disabled="isLoadingMore">
        {{ isLoadingMore ? getLabel('loading') : getLabel('showMore') }}
      </button>
    </div>
  </article>

  <template v-if="isLoadingMore">
    <div class="kb-spinner-overlay">
      <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
    </div>
  </template>

</template>
